<template>
    <div class="border p-2 mt-4">
        <form @submit.prevent="saveLimitation" id="limitation_form">
            <kt-form-group v-if="!gateway.has_limit" style="margin-top: 10px;">
                <div class="custom-control custom-switch">
                    <input type="checkbox" class="custom-control-input" id="has_limit1" name="has_limit"
                           v-model="gateway.has_limit">
                    <label class="custom-control-label" for="has_limit1">{{ $t('label.amount_limitation') }}</label>
                </div>
            </kt-form-group>

            <div class="container p-3 pt-5 my-4 border in-border-header" v-if="gateway.has_limit">
                <kt-form-section is_first>
                    <div class="section-header" style="right: -5px;">
                        <kt-form-group class="mb-0">
                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="has_limit2" name="has_limit"
                                       v-model="gateway.has_limit">
                                <label class="custom-control-label" for="has_limit2">{{ $t('label.amount_limitation') }}</label>
                            </div>
                        </kt-form-group>
                    </div>

                    <kt-form-group v-if="gateway.has_limit">
                        <kt-form-label>
                            {{ $t('label.limit_amount') }}
                        </kt-form-label>
                        <div class="kt-input-icon kt-input-icon--right">
                        <span class="kt-input-icon__icon kt-input-icon__icon--right">
                            <span>{{ $t('label.rial') }}</span>
                        </span>
                            <kt-form-control
                                    type="text"
                                    dir="ltr"
                                    id="limit_amount"
                                    name="limit_amount"
                                    v-model="gateway.limit_amount"
                            >
                            </kt-form-control>
                        </div>
                    </kt-form-group>
                </kt-form-section>
            </div>

            <kt-form-group>
                <div class="custom-control custom-switch">
                    <input
                            type="checkbox"
                            class="custom-control-input"
                            id="server_ip_limitation"
                            name="server_ip_limitation"
                            v-model="gateway.server_ip_limitation"
                    >
                    <label class="custom-control-label" for="server_ip_limitation">{{
                        $t('label.server_ip_limitation') }}</label>
                </div>
            </kt-form-group>
            <div>
                <button type="submit"
                        class="btn btn-success"
                        id="save_limitation"
                        v-text="$t('btn.submit_changes')"
                >
                </button>
            </div>
        </form>
    </div>
</template>

<script>
    import $ from "jquery";
    import {KTApp} from "@/plugins/core/app";
    import {ivrService} from "@/common/api.service";
    import {i18n} from "@/plugins/i18n";

    export default {
        data() {
            return {
                gateway: {},
            };
        },
        mounted() {
            ivrService.getLimitation(this.$route.params.hashid).then(res => {
                this.gateway = res.data.data;
            });
        },
        methods: {
            saveLimitation(e) {
                let btn = $('#save_limitation');
                let form = $('#limitation_form');

                form.validate({
                    rules: {
                        limit_amount: {
                            required: this.gateway.has_limit,
                            min: 1000,
                            digits: true
                        }
                    }
                });

                if (!form.valid()) {
                    return
                }

                KTApp.progress(btn);

                ivrService.changeLimitation(this.$route.params.hashid, {
                    has_limit: this.gateway.has_limit,
                    server_ip_limitation: this.gateway.server_ip_limitation,
                    limit_amount: this.gateway.limit_amount,
                })
                .catch(({response}) => {
                    this.showMsg(form, 'danger', i18n.t('message.an_error_accord'))
                })
                .finally(response => {
                        KTApp.unprogress(btn);
                        this.showMsg(form, 'success', i18n.t('message.changes_submitted_successfully'))
                    }
                )
            },
        },
    }
</script>

<style>
</style>
